// Modal handler utilities for PdfTableViewer
import { getCellDifferences } from "./tableCalculations";

/**
 * Handle cell detail click to show detail modal
 */
export const handleCellDetailClick = (
  rowIndex,
  colIndex,
  cellContent,
  tableData,
  isAfter = false,
  { pendingGridLineChanges, selectedTable, pdfPageDimensions, modalState }
) => {
  if (!pendingGridLineChanges) return;

  const differences = getCellDifferences(
    pendingGridLineChanges.originalTableData,
    pendingGridLineChanges.newTableData,
    pendingGridLineChanges,
    selectedTable,
    pdfPageDimensions
  );
  const cellKey = `${rowIndex}_${colIndex}`;
  const hasChange =
    differences.changes && differences.changes.has
      ? differences.changes.has(cellKey)
      : false;
  const changeInfo = differences.cellMap[cellKey];

  // For new columns/rows, the originalContent should be empty
  let originalContent = "";
  let newContent =
    pendingGridLineChanges.newTableData.rows[rowIndex]?.[colIndex] || "";

  if (changeInfo && changeInfo.type === "added") {
    // This is a new cell (from new column/row) - original should be empty
    originalContent = "";
  } else {
    // This is an existing cell - get original content
    originalContent =
      pendingGridLineChanges.originalTableData.rows[rowIndex]?.[colIndex] || "";
  }

  modalState.setSelectedCellDetail({
    rowIndex,
    colIndex,
    cellContent,
    headerName: tableData.headers[colIndex] || `Column ${colIndex + 1}`,
    hasChange,
    changeInfo,
    isAfter,
    originalContent,
    newContent,
  });
  modalState.setShowCellDetail(true);
};

/**
 * Add new column with specified header - called after grid line placement
 */
export const addNewColumnGlobally = ({
  pendingGridLineChanges,
  newColumnHeader,
  gridLineState,
  modalState,
}) => {
  if (!pendingGridLineChanges || !newColumnHeader?.trim()) {
    return;
  }

  // Determine which column was added (the new column should be the last one)
  const originalColumnCount =
    pendingGridLineChanges.originalTableData.headers.length;
  const newColumnCount = pendingGridLineChanges.newTableData.headers.length;

  if (newColumnCount > originalColumnCount) {
    // Find the column with the placeholder name and replace it
    const updatedHeaders = [...pendingGridLineChanges.newTableData.headers];

    // Find the placeholder column (NewColumn_X)
    let placeholderIndex = -1;

    for (let i = 0; i < updatedHeaders.length; i++) {
      if (updatedHeaders[i].startsWith("NewColumn_")) {
        placeholderIndex = i;
        break;
      }
    }

    if (placeholderIndex >= 0) {
      updatedHeaders[placeholderIndex] = newColumnHeader.trim();
    } else {
      // Fallback - update the last column
      updatedHeaders[newColumnCount - 1] = newColumnHeader.trim();
    }

    const updatedTableData = {
      ...pendingGridLineChanges.newTableData,
      headers: updatedHeaders,
    };

    // Update pending changes with the new header
    gridLineState.setPendingGridLineChanges({
      ...pendingGridLineChanges,
      newTableData: updatedTableData,
    });
  }

  // Show grid line confirmation with before/after preview
  modalState.setShowGridLineConfirmation(true);
};
